import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import { useTranslation } from 'next-i18next';
import { ElasticSearch } from '@interfaces/models/elasticSearch';
import { usePreferences } from '@context/preferences.context';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import getCatalogQueryIndex from '@helpers/utils/catalog-query-index';
import HotfilterSort from '@components/organisms/hot-filters/hot-filter-sort/hot-filter-sort';
import { getDefaultSortBy } from '@helpers/utils/catalog/catalog-url-helpers';
import { useRouter } from 'next/router';
interface CatalogHotfilterSortbyProps {
  setIsFilterOpen: (state: boolean) => void;
}

const CatalogHotfilterSortby: React.FC<CatalogHotfilterSortbyProps> = ({ setIsFilterOpen }) => {
  const { t } = useTranslation();
  const sortBy = useContextSelector(CatalogContext, (v) => v.sortBy);
  const setSortBy = useContextSelector(CatalogContext, (v) => v.setSortBy);
  const { country } = usePreferences();
  const { sendAnalyticEvent } = useAnalyticEvents('catalog');

  const handleChange = (value: ElasticSearch['sortBy']) => {
    sendAnalyticEvent('sorting_change', {
      action: getCatalogQueryIndex(country, value),
    });
    setSortBy(value);
  };

  const { asPath } = useRouter();

  const defaultSortBy = getDefaultSortBy(asPath);

  return (
    <HotfilterSort
      defaultSortValue={defaultSortBy}
      value={sortBy}
      onChange={handleChange}
      setIsFilterOpen={setIsFilterOpen}
      options={[
        { text: t('CATALOG.SORT.RELEVANCE'), value: 'relevance' },
        { text: t('CATALOG.SORT.PRICE_ASC'), value: 'price-asc' },
        { text: t('CATALOG.SORT.PRICE_DESC'), value: 'price-desc' },
        { text: t('CATALOG.SORT.MOST_RECENT'), value: 'recency' },
      ]}
    />
  );
};

export default CatalogHotfilterSortby;
